var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShams(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.47 71.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shams-04"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.3,0l9.87,10.9c.46.51.94.85.13,1.57s-1,0-1.38-.39Q7.83,6.55,2.8,1C2.54.7,2.12.49,2.15,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.86,69.16c-3.28-3.63-6.55-7.28-9.86-10.88-.61-.67-.79-1.1,0-1.69.35-.26.52-.32.85,0Q61.44,62.83,67,69c5.56,6.17,0,.1,0,.15Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,2.15c.43-.06.62.31.87.53L12.21,13c.39.35.91.59.26,1.28s-.92.48-1.46,0C7.36,10.94,3.67,7.63,0,4.3Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,67c-.43,0-.62-.32-.86-.55Q62.62,61.32,57,56.15c-.37-.34-1-.57-.27-1.27s.91-.5,1.46,0c3.65,3.34,7.33,6.65,11,10Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67,0c-.25.89-1,1.37-1.58,2-3.07,3.41-6.17,6.8-9.26,10.2-.36.38-.6.93-1.29.27s-.48-.93,0-1.47c3.33-3.65,6.64-7.33,10-11Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,4.3c-3.63,3.29-7.27,6.56-10.87,9.87-.64.58-1.1.84-1.69,0-.23-.34-.36-.51,0-.84,4.24-3.7,8.14-7.73,12.56-11.18Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.15,69.16a17.14,17.14,0,0,1,3-3.58c2.51-2.81,5.08-5.58,7.61-8.38.45-.51.76-.84,1.47-.25s.19,1-.19,1.44Q9.2,63.77,4.3,69.16Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,64.86l10.75-9.72c.41-.37.72-1.08,1.45-.28s.24,1.09-.3,1.58Q6.31,61.5.74,66.59c-.21.19-.36.52-.74.42Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,7.38c3.38,2.55,6.77,5.1,10.13,7.68.38.29,1.27.39.59,1.32s-1,.55-1.57.09c-3-2.33-6.1-4.63-9.15-6.94Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,61.78c-3.33-2.52-6.67-5-10-7.59-.39-.3-1.43-.37-.73-1.41s1.26-.28,1.8.12c3,2.23,5.93,4.49,8.9,6.73Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.63,69.16c-2.31-3-4.61-6.11-6.94-9.14-.46-.61-.7-1,.1-1.57s1,.21,1.32.58c2.57,3.36,5.12,6.75,7.67,10.13Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.78,0c-2.46,3.26-4.9,6.54-7.42,9.75-.33.42-.35,1.74-1.57.95s-.19-1.36.2-1.89c2.19-3,4.42-5.88,6.64-8.81Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,9.53c-3,2.31-6.12,4.61-9.15,7-.61.47-1,.68-1.56-.09s.08-1,.46-1.24Q64,11.26,69.16,7.38Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.68,69.16c-.18-.5.26-.73.49-1,2.23-3,4.52-5.92,6.7-8.94.59-.82,1.19-.93,1.85-.42s-.11,1-.38,1.34c-2.25,3-4.54,6-6.81,9Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.53,0c2.31,3.05,4.6,6.11,6.93,9.14.45.59.75,1-.06,1.56s-1-.19-1.35-.59C12.48,6.75,9.93,3.37,7.38,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,59.63l9.28-7c.4-.3.8-.79,1.22,0,.3.52.45,1-.18,1.45C7,56.48,3.71,59,.4,61.47c-.08.07-.26,0-.4,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55,69.16c-1.59-2.55-3.19-5.09-4.77-7.65-.24-.38-.78-.82-.06-1.26s1.09-.39,1.49.3c1.69,2.89,3.66,5.62,5.18,8.61Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,12.29c3,1.51,5.67,3.43,8.5,5.15a1,1,0,0,1,.6,1.28,1,1,0,0,1-.16.28c-.46.75-.88.21-1.27,0L0,14.14Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.29,69.16c1.52-3,3.49-5.71,5.18-8.59.29-.48.68-.85,1.18-.44s.76.7.3,1.39c-1.65,2.52-3.21,5.09-4.81,7.64Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.14,0C15.76,2.6,17.38,5.21,19,7.8c.31.49.47.84-.19,1.21s-.89.36-1.25-.23Q15,4.39,12.29,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,55c2.5-1.56,5-3.09,7.5-4.69a1.06,1.06,0,0,1,1.5,0,1.27,1.27,0,0,1,.18.27c.42.69-.29.85-.69,1.09C5.66,53.44,3,55.38,0,56.86Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,56.86c-2.93-1.76-5.85-3.53-8.78-5.28-.6-.36-.52-.7-.23-1.24.37-.69.72-.5,1.21-.2,2.59,1.64,5.2,3.26,7.8,4.88Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.86,0c-1.57,2.61-3.14,5.22-4.74,7.81-.14.24-.39.37-.47.71-.13.55-.37,1.05-1.16.6s-.64-.84-.25-1.45C51.85,5.13,53.43,2.56,55,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,14.14C66.57,15.76,64,17.38,61.39,19c-.5.31-.89.47-1.23-.2-.22-.44-.48-.8.11-1.15q4.45-2.67,8.89-5.38Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.44,0c.82,2.26,2.11,4.29,3.09,6.47.18.39.6.81-.13,1.09-.5.19-1.07.31-1.34-.28C18.92,4.85,17.44,2.57,16.6,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,50.72c2-1,4-1.89,6-2.88.7-.35,1.31-.64,1.74.3s-.47,1-.93,1.2A50.47,50.47,0,0,1,0,52.56Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,52.56c-2.58-.83-4.84-2.32-7.28-3.45-.64-.3-.48-.94-.2-1.47s.7-.14,1,0c2.18,1,4.21,2.26,6.47,3.08Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.56,0c-.82,2.59-2.32,4.85-3.45,7.3-.25.54-.75.58-1.3.3s-.4-.69-.19-1.12Q49.18,3.24,50.72,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,16.6c2.57.8,4.83,2.29,7.24,3.44a.87.87,0,0,1,.47,1.15.72.72,0,0,1-.12.21c-.44.69-.87.26-1.29.06-2.11-1-4.11-2.2-6.3-3Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.72,69.16c-1-2.15-2-4.3-3.09-6.44-.24-.5-.45-.9.25-1.21s1-.14,1.27.39c1.09,2.44,2.62,4.68,3.41,7.26Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,18.44l-6.32,3c-.41.19-.9.69-1.24-.1-.22-.51-.29-1.06.29-1.33a69.91,69.91,0,0,1,7.27-3.44Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.6,69.16a66.85,66.85,0,0,1,3.57-7.5c.17-.35.37-.54.81-.16s.93.51.55,1.24c-.79,1.52-1.54,3.07-2.3,4.62-.28.59-.52,1.2-.79,1.8Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.13,0q1,2.57,1.93,5.12c.2.54.68,1-.3,1.44s-1.08-.38-1.28-.88C21.71,3.8,21,1.9,20.29,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47,69.16c-.63-1.66-1.28-3.31-1.88-5-.19-.54-.8-1.13.27-1.6s1.08.38,1.28.89c.76,1.88,1.45,3.79,2.17,5.68Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,47l5.13-2c.55-.21,1-.63,1.45.33s-.17,1-.73,1.24C3.91,47.4,2,48.13,0,48.87Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,48.87c-1.86-.71-3.73-1.39-5.56-2.16-.45-.2-1.48,0-1-1.21s1.14-.51,1.7-.32c1.64.57,3.26,1.23,4.88,1.85Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.29,69.16c.72-1.9,1.41-3.81,2.19-5.69.17-.43.05-1.34,1.14-.94s.75.83.48,1.51c-.68,1.69-1.32,3.41-2,5.12Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.87,0c-.7,1.84-1.37,3.71-2.14,5.52-.2.48,0,1.6-1.31,1S45,5.37,45.2,4.84C45.76,3.21,46.41,1.61,47,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,22.13c-1.56.6-3.1,1.25-4.69,1.77-.56.19-1.29,1.13-1.85-.16s.64-1.12,1.16-1.35c1.77-.76,3.58-1.41,5.38-2.1Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,20.29c2,.74,3.9,1.46,5.84,2.24.44.17,1.16.16.79,1.1s-.69.8-1.37.52c-1.74-.7-3.51-1.35-5.26-2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.82,0a14.12,14.12,0,0,0,1.06,4.24c.31,1-.27,1.24-.78,1.46-.75.34-.75-.47-.87-.88C24.78,3.22,24.39,1.61,24,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,69.16c.42-1.66.82-3.33,1.29-5,.1-.37.16-1.11.82-.74.42.23,1.12.42.82,1.33a16.62,16.62,0,0,0-1.09,4.39Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,43.34a18.37,18.37,0,0,0,3.66-.86A2.67,2.67,0,0,1,5,42.28a1,1,0,0,1,.83.93c.09.5-.37.57-.68.64A39.72,39.72,0,0,1,0,45.18Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,45.18c-1.71-.44-3.41-.87-5.11-1.33-.47-.12-.9-.35-.57-1s.41-.78,1.23-.59c1.49.32,2.86,1.16,4.45,1Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.65,69.16c-.46-1.49-.88-3-1.39-4.47a.79.79,0,0,1,.29-1.08,1.06,1.06,0,0,1,.25-.09c.65-.26,1,.17,1.1.67a39.41,39.41,0,0,1,1.28,5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.18,0c-.43,1.67-.85,3.33-1.3,5-.12.42-.19,1-.88.72-.53-.21-1-.43-.75-1.22.51-1.48.94-3,1.4-4.49Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,25.82c-1.51,0-2.84.71-4.28,1-.62.14-1.11.28-1.32-.47s.25-.74.85-1A26.24,26.24,0,0,1,69.16,24Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,24c1.66.43,3.34.82,5,1.33.3.09.89.36.69,1a.86.86,0,0,1-1,.72L4.55,27A21.6,21.6,0,0,0,0,25.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,41.8c-1.4-.21-2.81-.42-4.21-.65-.54-.09-1-.3-.8-1a.87.87,0,0,1,1-.77.74.74,0,0,1,.29.08,9.06,9.06,0,0,0,3.76.51Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,40a10.35,10.35,0,0,0,3.83-.51c.7-.28,1,.11,1.22.72.3.78-.21.88-.71,1-1.45.24-2.89.45-4.34.67Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.8,0l-.66,4.23c-.1.69-.41.92-1.16.78s-.63-.59-.55-1.12c.2-1.29.74-2.54.53-3.89Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.36,69.16a33.82,33.82,0,0,1,.9-5.1c1.53.59,1.47.58,1.32,2-.12,1-.64,2-.38,3.14Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.27,69.16c-.28-1.3-.51-2.6-.85-3.88-.19-.72.28-.72.69-.88.57-.21.93,0,1,.54.26,1.4.45,2.81.67,4.22Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.89,0c.28,1.28.51,2.57.86,3.83.21.79-.35.81-.78,1A.7.7,0,0,1,28,4.21c-.24-1.38-.44-2.78-.66-4.17Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,27.66c1-.77,1.86.52,2.87.2.15-.05.68.26,1.15.16a.93.93,0,0,1,1,.9.73.73,0,0,1-.57.86.71.71,0,0,1-.43,0c-1.34-.27-2.67-.56-4-.85Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,29.2c-1.3-.21-2.5.31-3.74.51-.67.11-1.2,0-1.21-.7,0-.52.18-.94,1-.87,1.34.12,2.55-.8,3.92-.78Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.88,69.16c-.09-1.11-.19-2.22-.29-3.33,0-.53-.1-1,.7-1s1,.15,1.08.88c.08,1.16.24,2.31.36,3.47Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.73,0a15.7,15.7,0,0,0-.37,3.35c-.06.65-.22,1.3-1,1.25s-.79-.77-.74-1.39c.09-1.07.19-2.14.28-3.21Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.27,0c.1,1.1.21,2.21.3,3.31,0,.52.11,1-.69,1s-1-.2-1.07-.89A17.06,17.06,0,0,0,30.43,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.43,69.16a13.73,13.73,0,0,0,.36-3.32c.07-.67.24-1.1,1.11-1s.7.67.67,1.17c-.07,1.06-.2,2.12-.3,3.18Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,38.42a14.14,14.14,0,0,1-3.5-.09c-.6,0-1.2-.26-1.09-1s.7-.77,1.27-.75a2.72,2.72,0,0,1,1.45.36,1.68,1.68,0,0,0,1.87-.08Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.35,0V3.64c0,.56-.09.95-.82.95s-.83-.37-.81-.95V0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.81,69.16c0-1.22,0-2.45-.07-3.67,0-.62.14-.92.85-.92s.87.29.84.92c0,1.22-.06,2.45-.08,3.67Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,30.74a5.94,5.94,0,0,0,2.78,0,1.49,1.49,0,0,1,1.3.3c.33.26.69.45.52,1a.79.79,0,0,1-.95.56L0,32.27Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,37.19a4.8,4.8,0,0,0,2.5-.46,1.76,1.76,0,0,1,1.61,0,.92.92,0,0,1,.55,1c0,.54-.37.53-.71.57A14.93,14.93,0,0,1,0,38.42Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,32.27c-1.06.1-2.11.21-3.17.28-.59,0-1.4.22-1.4-.66a1.15,1.15,0,0,1,1.2-1.11.86.86,0,0,1,.28,0,6.86,6.86,0,0,0,3.09-.08Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,34.12c1.28-.23,2.61.24,3.88-.31.36-.15.71,0,.68.51s.22,1.08-.62,1.07L0,35.35Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,35.35H65.35c-.61,0-.72-.23-.76-.8,0-.84.46-.49.83-.52,1.24-.08,2.52.25,3.74-.26Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.33,26.07c1.26-.23,1.66.27,1.54,1.46a3.78,3.78,0,0,0,.84,2.87,1.42,1.42,0,0,0,1.64.55c.6-.22.54-.79.54-1.3V26.88c0-.58.18-.81.79-.81s.79.25.78.82a5.42,5.42,0,0,0,.42,3A1.69,1.69,0,0,0,24.71,31c.89-.17.74-1,.75-1.62V26.61c0-.55.11-.85.76-.84s.77.32.75.87V29.1a2.83,2.83,0,0,0,3.22,2.38,2.71,2.71,0,0,0,.78-.24,1.72,1.72,0,0,0,.72-1.59c.1-3.47.12-3.47,3.46-3.54,2.76-.05,3,.16,3.33,3a2.76,2.76,0,0,0,3.1,2.38,2.69,2.69,0,0,0,.62-.16,1.47,1.47,0,0,0,.86-1.5V26.11c1.38-.34,1.59.36,1.53,1.49a3.45,3.45,0,0,0,1.1,3.06c.32.26.52.92,1.08.64a1.41,1.41,0,0,0,.85-1.3V26.77c0-.55,0-1,.77-1s.77.43.77,1c0,1.31-.23,2.73.89,3.75.37.33.63,1.12,1.31.81a1.67,1.67,0,0,0,.84-1.67V26.89c0-.46-.21-1.06.65-1.09s.75.63.76,1.16v2.91c-.06,2.43-2,3.47-4,2.16-.57-.36-.85-.57-1.48,0-1,.94-2.19.65-3.23-.1-.39-.27-.65-.59-1.16-.18a4.31,4.31,0,0,1-5.34.08c-.47-.3-.61-.18-1,.1a3.14,3.14,0,0,1-3.84.09c-.35-.2-.52-.65-1.12-.18-1.63,1.27-3.47.94-5.22.26-.55-.22-.85-.45-1.41,0a2.09,2.09,0,0,1-2.72,0c-.81-.62-1.26-.45-2,.07-1.07.75-2.15.22-3.23-.43-.1,1.81-.65,3.27-2.58,3.68a4.62,4.62,0,0,1-4.78-1.73c-1.73-2.1-1.84-4.57-1.35-7.13.14-.72.64-.52,1.06-.52.69,0,.51.53.43.88a8.41,8.41,0,0,0,0,3.8c.39,1.79,1.7,2.73,3.1,3.54,1,.55,2.47-.74,2.51-2.14C16.37,30.14,16.33,28.09,16.33,26.07ZM35,27.27c-2,0-2.18.28-1.55,2.12A2,2,0,0,0,35.76,31l.13,0c1.33-.25,1.16-1.38,1.12-2.33C37,27.29,36,27.18,35,27.27Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.1,44.09A7.89,7.89,0,0,1,18.16,43c-.45-.26-.87-.49-.44-1.18s.64-.35,1.09-.12a7,7,0,0,0,4.36.79c.8-.13,1.47-.44,1.65-1.19s-.53-1.18-1.17-1.36c-1.22-.35-2.48-.56-3.7-.91s-2.28-.89-2.25-2.34,1-1.8,2.21-2.39c2.15-1,3.83.1,5.7.42.5.09.64.41.36.91s-.4.8-1,.46a5.84,5.84,0,0,0-3.25-.71,3.11,3.11,0,0,0-.61,0c-.77.21-1.89.3-1.83,1.25s1.21,1.14,2,1.21a11.45,11.45,0,0,1,3,.62,2.69,2.69,0,0,1-.14,5.31A20.38,20.38,0,0,1,22.1,44.09Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43,40.52V37.91c0-.86.54-1,.94-.73,1.05.75,2.07.14,3.1.14.15,0,.38-.1.42,0,1.11,1.4,2.32,0,3.47,0,1.61.06,2.52.5,2.59,2.09.06,1.23,0,2.46,0,3.69,0,.51,0,.87-.71.85s-.82-.22-.81-.81V40.23c0-.58.21-1.33-.63-1.53a1.61,1.61,0,0,0-1.88,1A6.5,6.5,0,0,0,49,42.84a2,2,0,0,1-.09.91c-.15.3-.54.19-.84.18s-.46-.32-.46-.64V40.22c0-.6,0-1.33-.72-1.51a1.57,1.57,0,0,0-1.8.87,5.35,5.35,0,0,0-.78,3.19c0,.46.32,1.22-.68,1.18s-.55-.7-.58-1.13C43,42.05,43,41.28,43,40.52Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.52,41c0,.71-.05,1.43,0,2.14a.74.74,0,0,1-1.13.77c-.63-.9-1.14-.3-1.72-.1A2.92,2.92,0,0,1,35,42.27c-.77-1.74-.17-4.09,1.16-4.81.66-.37,1.26,0,1.89,0C41.52,37.47,41.52,37.5,41.52,41Zm-5.27-.53c-.07,1,.17,2,1.3,2.22s2.32-1.47,2.44-3c.09-1.21-.65-1-1.35-1-2.08-.09-2.39.15-2.39,1.77Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,38c.94-1,1.94-.54,2.84-.69s1.61.81,1.69,1.8c.09,1.38,0,2.76,0,4.14,0,.53-.21.69-.72.7S32,43.8,32,43.18V40.12c0-.54.16-1.2-.59-1.4a1.53,1.53,0,0,0-1.72.72A5.72,5.72,0,0,0,29,42.66a2.91,2.91,0,0,1-.11,1.06c-.14.31-.53.22-.83.19-.53,0-.47-.45-.47-.79V34.39c0-.56.14-.86.78-.84s.64.37.64.81Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.38,38.91c.54.71.9,1,1.73.85a2.45,2.45,0,0,1,2.47,1.91c.07,1.45-.91,1.95-2.09,2.2a4.83,4.83,0,0,1-3.23-.69c-.46-.24-.72-.49-.33-1.06s.53-.64,1.06-.29c.93.6,1.89,1.61,3,.19.22-.3.17-.31-2.48-1.12-1.1-.33-1.84-.91-1.47-2.21a1.53,1.53,0,0,1,1.68-1.36,1.66,1.66,0,0,1,.45.12c.83.22,1.68-.47,2.51,0,.35.2,1,.13.68.88-.23.55-.45.88-1.12.58A3.64,3.64,0,0,0,56.38,38.91Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.33,24.11c-.11.65-.49,1-1,1a.88.88,0,0,1-.92-.84.86.86,0,0,1,0-.16.79.79,0,0,1,.82-.88A1.3,1.3,0,0,1,51.33,24.11Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.35,23.37c.46-.44-.55-1.78,1-1.58.43.06,1-.08,1,.6a.94.94,0,0,1-.88,1h0c-.38.07-.72-.5-1.09,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.33,23.35a1,1,0,0,0-.08.29c0,.65.1,1.39-.94,1.31-.66,0-1-.43-.8-1,.23-.83.81-1,1.55-.58a.71.71,0,0,0,.29,0Z",
    transform: "translate(0 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShams);
export default __webpack_public_path__ + "static/media/shams.6ab9bab3a685f9856d40253792e28622.svg";
export { ForwardRef as ReactComponent };